import { apiRequest } from './client.js';

/**
 * Super-admin assignment of the platform branding catalogue to tenants.
 * Backed by v1/m17/branding-catalogue, which is guarded by PlatformAdminGuard.
 */

export interface CatalogueTenant {
  readonly tenantId: string;
  readonly tenantCode: string;
  readonly tenantName: string;
}

export interface CatalogueEntry {
  readonly catalogueCode: string;
  readonly catalogueName: string;
  readonly parentCode: string | null;
  readonly isType: boolean;
  readonly enabled: boolean;
  /** False when the tenant has no row yet — "never provisioned", not "switched off". */
  readonly materialised: boolean;
}

type Tok = string | null | undefined;

export const listCatalogueTenants = (token: Tok) =>
  apiRequest<CatalogueTenant[]>('/v1/m17/branding-catalogue/tenants', { token });

export const listCatalogueForTenant = (token: Tok, tenantId: string) =>
  apiRequest<CatalogueEntry[]>(`/v1/m17/branding-catalogue/${tenantId}`, { token });

export const setCatalogueEnabled = (
  token: Tok,
  tenantId: string,
  catalogueCode: string,
  enabled: boolean,
) =>
  apiRequest<CatalogueEntry>(
    `/v1/m17/branding-catalogue/${tenantId}/${encodeURIComponent(catalogueCode)}`,
    { method: 'PUT', token, body: { enabled } },
  );
